import React from 'react'
import './register.less'
import api from '../../api/api.js'
import {API_CONFIG} from '../../api/config.js'
import ysxieyi from './ysxieyi.jsx';
import xieyi from './xieyi.jsx'
import safe from './safe'
import md5 from 'md5'
import { Input, Select, Form, Button, message,  Checkbox } from 'antd'
const { Option } = Select;

class Sign extends React.Component {
   constructor(props) {
        super(props)
        this.isfocus = false
        this.state = {
            confim_mobile: false,
            checked: false,
            confim_psw: false,
            confirmDirty: false,
            t60: 60,
            mobile: '',
            sms_code: '',
            register_loading: false,
            getcode_loding:false,
            team:[],
            isfocus: false
        }
   }
    componentDidMount() {
        console.log(this.props,)
    }
    // 提交
    handleSubmit = e => {
        e.preventDefault();
        if(!this.state.checked){
            message.error('请阅读并同意 《法律声明及隐私权政策》《物业云平台服务协议》《订单共享与安全》')
            return
        }
        this.props.form.validateFields((err, values, callback) => {
            if (!err) {
                if (values.captcha && values.phone && values.password) {
                    //注册
                    this.setState({ register_loading: true });
                    api.account_register({
                        mobile: this.state.mobile,
                        sms_code: this.state.sms_code,
                        password: md5(values.password)
                    }).then(res => {
                        this.setState({ register_loading: false })
                        if (res.code === 0) {
                            clearInterval(this.timer)
                            this.setState({  t60: 60 })
                            sessionStorage.setItem('userInfo',
                            JSON.stringify({
                                mobile: this.state.mobile,
                                sms_code: this.state.sms_code,
                                account_uuid: res.content.account_uuid
                            }))
                            document.cookie= `${API_CONFIG.company_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                            sessionStorage.setItem('access_token', res.content.access_token);
                            this.props.set_key('3')
                        }
                    }).catch((err) => {
                        this.setState({ register_loading: false })
                    })
                } else  if (values.captcha && values.phone) {
                    //已填手机和验证码,  验证码验证查询否有团队及团队名称
                    this.setState({ register_loading: true })
                    this.setState({ mobile: values.phone, sms_code: values.captcha, },()=>{
                        api.check_has_group({
                            mobile: this.state.mobile,
                            sms_code: this.state.sms_code,
                        }).then(res=>{
                            this.setState({ register_loading: false })
                            if(res.code===0){
                                clearInterval(this.timer)
                                this.setState({  t60: 60 })
                                this.setState({team:res.content.team})
                                sessionStorage.setItem('source',res.content.source);
                                sessionStorage.setItem('userInfo',
                                JSON.stringify({
                                    mobile: this.state.mobile,
                                    sms_code: this.state.sms_code,
                                    account_uuid: res.content.account_uuid
                                }))
                                sessionStorage.setItem('access_token', res.content.access_token);
                                document.cookie= `${API_CONFIG.company_token}=${res.content.access_token};domain=colourlife.com;;path=/;`
                                if(res.content.register === 1){
                                    //已注册
                                    if (res.content.has_team === 2||!res.content.team.length) {
                                        //无团队
                                        this.props.has_team(false)
                                        this.props.set_key('3')
                                    } else if (res.content.has_team === 1 && res.content.team.length ) {
                                        //有团队
                                        sessionStorage.setItem('team', JSON.stringify(res.content.team))
                                        this.props.has_team(true);
                                    } 
                                }else{
                                    //未注册
                                    this.setState({confim_psw: true})
                                }
                            } else {
                                this.setState({ register_loading: false })
                            } 
                        }).catch(err => {
                            this.setState({ register_loading: false })
                        })
                    })
                } 
            }
        });
    };
    
    validateMobile() {
        const { getFieldValue } = this.props.form;
        if(!getFieldValue('phone')) {
            message.error('请输入您的手机号')
            return;
        } else{
            let pattern = /^1[3456789]\d{9}$/
            if(!pattern.test(getFieldValue('phone'))){
                message.error('手机号填写不正确')
                return
            }
            if(this.state.t60 !== 60) return;
            this.getCode()
        }    
    }
    // 注册发送验证码
    getCode = () => {
        console.log(this.props.form.getFieldValue('phone'))
        var that = this;
        this.setState({getcode_loding:true, t60: 59});
        api.sms_send_code({
            mobile: this.props.form.getFieldValue('phone'),
            type: 1
        }).then(res => {
            console.log(res);
            this.setState({getcode_loding:false});
            if (res.code === 0) {
                message.success(res.content.notice);
                var tt = that.state.t60;

                this.timer = setInterval(() => {
                    tt--;
                    if (tt === 0) {
                        clearInterval(this.timer)
                        that.setState({ t60: 60 })
                    } else {
                        that.setState({ t60: tt });
                    }
                }, 1000)
            } else{
                message.error( 'code:' + res.code);
                clearInterval(this.timer)
            }
        }).catch(err => {
            message.error( 'err:' + err);
            clearInterval(this.timer)
            this.setState({getcode_loding:false});
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const prefixSelector = getFieldDecorator('prefix', {
            initialValue: '86',
          })(
            <Select style={{ width: 70 }}>
                <Option value="86">+86</Option>
                <Option value="87">+87</Option>
                <Option value="60">+60</Option>
                <Option value="91">+91</Option>
                <Option value="1">+1</Option>
                <Option value="32">+32</Option>
            </Select>,
          );
        const { isfocus, confim_psw, checked, register_loading } = this.state
        return (
        <div className=''>
            <Form>
                <Form.Item 
                // label="手机号"
                 className={ isfocus ? 'special-item phone-item'  : 'special-item' } >
                {getFieldDecorator('phone', {
                    rules: [
                        { required: true, message: '请输入手机号',  pattern: /^1[3456789]\d{9}$/, },
                    ],
                })(<Input 
                    // addonBefore={prefixSelector} 
                    placeholder='请输入手机号' 
                    autoComplete="off"
                    onFocus={() => {
                        this.setState({
                            isfocus: true
                        })
                    }} 
                    onBlur={() => {
                        this.setState({
                            isfocus: false
                        })
                    }} 
                    />)}
                      <span  className='label'  > 手机： </span>
                     <span  ><img src={require("./../../imgs/mobile.png")} alt=""/></span>
                </Form.Item>
                <Form.Item 
                // label="验证码"
                 className='item code-item'>
                    {getFieldDecorator('captcha', {
                        rules: [{ required: true, message: '请输入验证码' }],
                    })(<Input placeholder='请输入验证码'  autoComplete="off"/>)}
                    <span  className='label'  > 验证码： </span>
                    <span 
                        className='code-text' 
                        onClick={() => {
                            this.validateMobile()
                        }} 
                        style={this.state.t60 === 60 ? {cursor:'pointer'} : {color:'#bfbfbf'}}
                    >  {this.state.t60 === 60 ? '点击发送验证码' : (this.state.t60 + '秒后重新获取')}</span>
                </Form.Item>
                {confim_psw ?  
                <Form.Item label="密码" className='item'>
                    {getFieldDecorator('password', {
                        rules: [{ required: true, message: '请设置8-16位数字和字母的密码' , pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/ }],
                    })(<Input.Password placeholder='请设置8-16位数字和字母的密码'  autoComplete="off"/>)}
                </Form.Item> : ''}
                <Button type='primary' className='register-btn' onClick={this.handleSubmit} loading={register_loading}>{confim_psw ? '注册' : '下一步'}</Button>
               <div >
               <Checkbox 
                    checked={checked} 
                    onChange={() => {
                        this.setState({
                            checked: !checked
                        })
                    }}
                >
                    已阅读并同意 
                    <a onClick={()=>{ysxieyi();}}>《法律声明及隐私权政策》</a>
                    <a onClick={()=>{xieyi();}}>《物业云平台服务协议》</a>
                    <a onClick={()=>{safe();}}>《订单共享与安全》</a>
                </Checkbox>
               </div>
            </Form>
        </div>
        )
    }
}
export default Form.create({})(Sign);


// WEBPACK FOOTER //
// ./src/pages/register/Sign.jsx